import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { validatePassword, PASSWORD_HINT } from '../utils/passwordValidation';
import './ChangePasswordModal.css';

function ChangePasswordModal({ isOpen, onClose, onSuccess }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    const pwdError = validatePassword(newPassword);
    if (pwdError) {
      setError(pwdError);
      return;
    }
    setLoading(true);
    try {
      await authAPI.setPassword(newPassword);
      setSuccess(true);
      setNewPassword('');
      setConfirmPassword('');
      onSuccess?.();
      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setError('');
      setNewPassword('');
      setConfirmPassword('');
      setSuccess(false);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="change-password-overlay" onClick={handleClose}>
      <div className="change-password-modal" onClick={e => e.stopPropagation()}>
        <div className="change-password-header">
          <h2>Change Password</h2>
          <button type="button" className="change-password-close" onClick={handleClose} aria-label="Close">&times;</button>
        </div>
        {success ? (
          <p className="change-password-success">Password updated successfully.</p>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="change-password-error">{error}</div>}
            <div className="form-group">
              <label htmlFor="change-new-password">New password</label>
              <input
                type="password"
                id="change-new-password"
                value={newPassword}
                onChange={e => { setNewPassword(e.target.value); setError(''); }}
                required
                disabled={loading}
                autoComplete="new-password"
              />
              <small>{PASSWORD_HINT}</small>
            </div>
            <div className="form-group">
              <label htmlFor="change-confirm-password">Confirm new password</label>
              <input
                type="password"
                id="change-confirm-password"
                value={confirmPassword}
                onChange={e => { setConfirmPassword(e.target.value); setError(''); }}
                required
                disabled={loading}
                autoComplete="new-password"
              />
            </div>
            <div className="change-password-actions">
              <button type="button" className="btn-cancel" onClick={handleClose} disabled={loading}>Cancel</button>
              <button type="submit" className="btn-submit" disabled={loading}>{loading ? 'Updating...' : 'Update password'}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ChangePasswordModal;
